module.exports = __webpack_public_path__ + "fcc43362922c8fb0cdf797f5702ed800.png";